/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMinIcon20Regular = forwardRef('UiFrameSizeMinIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12 2a.75.75 0 0 1 .75.75V6c0 .69.56 1.25 1.25 1.25h3.25a.75.75 0 0 1 0 1.5H14A2.75 2.75 0 0 1 11.25 6V2.75A.75.75 0 0 1 12 2Z" }),
        React.createElement("path", { d: "M2.75 11.25a.75.75 0 0 0 0 1.5H6c.69 0 1.25.56 1.25 1.25v3.25a.75.75 0 0 0 1.5 0V14A2.75 2.75 0 0 0 6 11.25H2.75Z" }),
        React.createElement("path", { d: "M14 11.25A2.75 2.75 0 0 0 11.25 14v3.25a.75.75 0 0 0 1.5 0V14c0-.69.56-1.25 1.25-1.25h3.25a.75.75 0 0 0 0-1.5H14Z" }),
        React.createElement("path", { d: "M8.75 2.75a.75.75 0 0 0-1.5 0V6c0 .69-.56 1.25-1.25 1.25H2.75a.75.75 0 0 0 0 1.5H6A2.75 2.75 0 0 0 8.75 6V2.75Z" })));
});
